import React from 'react';
import { Link, useLocation } from 'react-router';
import { MdOpenInNew } from 'react-icons/md';
import { Alert } from 'antd';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { PrivateComponent } from '@/components/HasRights/HasRights';
import { Permissions } from '@/const/permissions';
import { IntlMessages } from '@/components';
import appRoutes from '@/configs/routes';
import getUrlPathnamePrefix from '@/lib/getUrlPathnamePrefix';
import styles from './EmptyDictionariesListAlert.module.css';



const EmptyDictionariesListAlert = ({ isLoading = false, options = [] }) => {
  const intl = useIntl();
  const { pathname } = useLocation();
  const urlPrefix = getUrlPathnamePrefix(pathname);

  return (
    <div>
      {!isLoading && options.length === 0 && (
        <Alert
          className={styles.descriptionAlignEnd}
          title={intl.formatMessage({ id: 'templates-form-field-empty-dictionaries-list' })}
          type="warning"
          showIcon
          description={
            <PrivateComponent allowedPermissions={[ Permissions.TRANSLATIONS.DICTIONARIES.LIST.CREATE ]}>
              <Link
                to={appRoutes.urlPageDictionaryCreate({ urlPrefix: urlPrefix === 'presets' ? null : urlPrefix })}
                target="_blank"
                className={styles.linkContainIcon}
              >
                <IntlMessages id='ui-dictionaries-create' />
                <MdOpenInNew className='hp-ml-8' size={16} />
              </Link>
            </PrivateComponent>
          }
        />
      )}
    </div>
  );
};

EmptyDictionariesListAlert.propTypes = {
  isLoading: PropTypes.bool,
  options: PropTypes.array,
};

export default EmptyDictionariesListAlert;
